(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-carousel')) {
    class HeroCarousel extends HTMLElement {
      connectedCallback() {
        if (this.isInitialized) {
          this.mobileMediaQuery.addEventListener('change', this.handleMediaChange);
          this.showSlide(this.currentIndex);
          this.startAutoplay();
          return;
        }

        this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-hero-dot]'));
        this.previousButton = this.querySelector('[data-hero-previous]');
        this.nextButton = this.querySelector('[data-hero-next]');
        this.hero = this.closest('.hero');
        this.blurredSlides = this.hero
          ? Array.from(this.hero.querySelectorAll('[data-hero-blurred-slide]'))
          : [];
        this.currentIndex = 0;
        this.autoplayTimer = null;
        this.mobileMediaQuery = window.matchMedia('(max-width: 749px)');
        this.handleMediaChange = () => this.showSlide(this.currentIndex);
        this.mobileMediaQuery.addEventListener('change', this.handleMediaChange);
        this.isInitialized = true;

        this.showSlide(0);
        if (this.slides.length < 2) return;

        this.previousButton?.addEventListener('click', () => {
          this.showSlide(this.currentIndex - 1);
        });

        this.nextButton?.addEventListener('click', () => {
          this.showSlide(this.currentIndex + 1);
        });

        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => this.showSlide(index));
        });

        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') this.showSlide(this.currentIndex - 1);
          if (event.key === 'ArrowRight') this.showSlide(this.currentIndex + 1);
        });

        this.hero?.addEventListener('mouseenter', () => this.stopAutoplay());
        this.hero?.addEventListener('mouseleave', () => this.startAutoplay());
        this.hero?.addEventListener('focusin', () => this.stopAutoplay());
        this.hero?.addEventListener('focusout', (event) => {
          if (!this.hero.contains(event.relatedTarget)) this.startAutoplay();
        });

        this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        this.mobileMediaQuery?.removeEventListener('change', this.handleMediaChange);
      }

      showSlide(index) {
        if (this.slides.length === 0) return;
        this.currentIndex = (index + this.slides.length) % this.slides.length;

        this.slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === this.currentIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', String(!isActive));

          slide.querySelectorAll('video').forEach((video) => {
            if (isActive && video.getClientRects().length > 0) {
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        });

        this.dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === this.currentIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', String(isActive));
        });

        this.blurredSlides.forEach((slide) => {
          slide.classList.toggle(
            'is-active',
            Number(slide.dataset.heroBlurredSlide) === this.currentIndex
          );
        });
      }

      startAutoplay() {
        const isThemeEditor = window.Shopify && Shopify.designMode;
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (isThemeEditor || prefersReducedMotion || this.slides.length < 2 || this.autoplayTimer) return;

        this.autoplayTimer = window.setInterval(() => {
          this.showSlide(this.currentIndex + 1);
        }, 5000);
      }

      stopAutoplay() {
        window.clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    customElements.define('hero-carousel', HeroCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
